import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import { UserFeedbackSubmission, UserFeedbackResponse } from "src/types/userFeedback";

class UserFeedbackAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/user/feedback");
  }

  async getUserFeedback(): Promise<UserFeedbackResponse> {
    return await this.jwtRequest("GET", undefined);
  }

  async submitUserFeedback(feedbackData: UserFeedbackSubmission): Promise<{ success: boolean; feedbackId: string }> {
    return await this.jwtRequest("POST", undefined, feedbackData);
  }
}

export { UserFeedbackAPIService };
